import { Divider } from "antd";
import React from "react";
import ChargeLineItem from "./charge-line-item";

export default function EditCharges({
  allCharges = [],
  charges = [],
  onAddCharge,
  onDeleteCharge,
  onUpdateCharge,
  billSubTotalBeforeCharges = 0,
  readOnly = false,
}) {
  // Get available charges (not already selected)
  const availableCharges = allCharges.filter(
    (charge) =>
      !charges.some((selectedCharge) => selectedCharge.chargeId === charge.id)
  );

  const handleAddCharge = () => {
    onAddCharge({
      chargeId: null,
      value: 0,
    });
  };

  return (
    <div>
      {/* <Divider orientation="left" orientationMargin={0} className="mb-1">
        Bill Charges
      </Divider> */}

      {charges.length === 0 ? (
        <div className="text-center py-3 text-muted">
          <span>No charges added to this bill</span>
        </div>
      ) : (
        <div className="row">
          <div className="col-md-6">Charge</div>
          <div className="col-md-4">Value</div>
          <div className="col-md-2"></div>
        </div>
      )}

      <Divider className="my-2" />

      <div className="row align-items-center">
        {charges?.map((charge) => (
          <ChargeLineItem
            key={charge.id}
            charge={charge}
            allCharges={allCharges}
            availableCharges={availableCharges}
            billSubTotalBeforeCharges={billSubTotalBeforeCharges}
            onDelete={onDeleteCharge}
            onUpdate={onUpdateCharge}
            readOnly={readOnly}
          />
        ))}
      </div>

      {!readOnly && availableCharges.length > 0 && (
        <button className="button is-small" autoFocus onClick={handleAddCharge}>
          <span className="bi bi-plus-circle me-2"></span>
          Add Charge
        </button>
      )}
    </div>
  );
}
